// @ts-nocheck
import { Plugin } from '/data/jenkins/workspace/aplus_tiger_copyright_complaint7c3c60c3-a5e2-4c8e-a871-1459b911c7e4_tiger-platform_udb_copyright_complaint_71743_nodejs_prod/node_modules/.pnpm/@umijs+runtime@3.5.32_react@16.14.0/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
